import MisurazioniList from "../misurazioni/pages/MisurazioniList"

export default {
    MisurazioniList
};